import React, { useState, useEffect } from 'react';
import { FiCode, FiServer, FiDatabase, FiTool, FiCpu } from 'react-icons/fi';
import './Skills.css';
import API_URL from '../config';

const Skills = () => {
  const [skillCategories, setSkillCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const iconMap = {
    programmingLanguages: <FiCode />,
    backend: <FiServer />,
    databases: <FiDatabase />,
    tools: <FiTool />,
    core: <FiCpu />
  };

  useEffect(() => {
    const fetchSkills = async () => {
      try {
        const res = await fetch(`${API_URL}/profile/skills`);
        const data = await res.json();
        if (data.success && data.data) {
          const withIcons = data.data.map(cat => ({ ...cat, icon: iconMap[cat.id] || <FiCode /> }));
          setSkillCategories(withIcons);
        }
      } catch (error) {
        console.error('Failed to fetch skills');
      }
      setLoading(false);
    };
    fetchSkills();
  }, []);

  if (loading) {
    return (
      <section className="skills section">
        <div className="container">
          <div className="section-title"><h2>Skills</h2></div>
          <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Loading...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="skills section">
      <div className="container">
        <div className="section-title"><h2>Skills</h2></div>

        <div className="skills-grid">
          {skillCategories.map((category, catIndex) => (
            <div key={category.id || catIndex} className="skill-card">
              <div className="skill-header">
                <span className="skill-icon">{category.icon}</span>
                <h3>{category.title}</h3>
              </div>

              <div className="skill-list">
                {category.skills?.map((skill, index) => (
                  <div key={index} className="skill-item">
                    <div className="skill-info">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-level">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <div className="skill-progress" style={{ width: `${skill.level}%` }}></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
